import { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

function Header() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/faqs", { state: { scrollTo: "enquiry" } });
  };

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const openInstagram = () =>
    window.open(
      "https://www.instagram.com/zrovamakeuphair/?hl=en",
      "_blank",
      "noopener,noreferrer",
    );

  const openWhatsApp = () =>
    window.open("https://wa.me/61449977179", "_blank", "noopener,noreferrer");

  useEffect(() => {
    const fadeElements = document.querySelectorAll(
      ".fade-up, .fade-left, .fade-right",
    );

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 },
    );

    fadeElements.forEach((el) => observer.observe(el));
    setIsOpen(false);

    return () => {
      observer.disconnect();
    };
  }, [location.pathname]);

  return (
    <header>
      <nav className="navbar navbar-expand-lg custom-nav">
        <div className="container">
          {/* Logo */}
          <img
            className="logo"
            src="/assets/LOGO.png"
            alt="ZROVA Makeup & Hair Sydney"
            height="70"
            loading="eager"
          />

          {/* Navbar toggler */}
          <button
            className={`navbar-toggler ${isOpen ? "" : "collapsed"}`}
            type="button"
            onClick={toggleNavbar}
            aria-controls="navbarNav"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
          >
            {isOpen ? (
              <span className="close-icon">✕</span>
            ) : (
              <span className="navbar-toggler-icon"></span>
            )}
          </button>

          {/* Nav links */}
          <div
            className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
            id="navbarNav"
          >
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" end>
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about">
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/services">
                  Services
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/gallery">
                  Gallery
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/products">
                  Products
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/faqs">
                  FAQs
                </NavLink>
              </li>
              <li className="nav-item">
                <button className="nav-link" onClick={handleContactClick}>
                  Contact
                </button>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact">
                  Book Now
                </NavLink>
              </li>
            </ul>

            {/* Instagram Icon */}
            <div className="navbar-icons d-flex align-items-center ms-lg-3">
              <button
                type="button"
                className="nav-link btn p-0"
                onClick={openInstagram}
                aria-label="Instagram"
              >
                <img
                  src="/assets/instagram.png"
                  alt="insta"
                  style={{
                    width: "22px",
                    height: "22px",
                    objectFit: "contain",
                  }}
                />
              </button>
            </div>

            {/* WhatsApp Icon */}
            <div className="navbar-icons d-flex align-items-center ms-lg-3">
              <button
                type="button"
                className="nav-link btn p-0"
                onClick={openWhatsApp}
                aria-label="WhatsApp"
              >
                <img
                  src="/assets/whatsapp.png"
                  alt="whatsapp"
                  style={{
                    width: "22px",
                    height: "22px",
                    objectFit: "contain",
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
